<article
  class="gallery-featured"
  [attr.aria-labelledby]="'featured-title-' + featured().id"
>
  <div class="gallery-featured__main">
    <div class="main-content">
      <figure class="main-content__image">
        <img
          [src]="featured().image"
          [alt]="featured().alternativeText"
          loading="lazy"
        />
      </figure>

      <div class="main-content__title">
        <app-icon [icon]="featured().icon" />

        <h2
          [id]="'featured-title-' + featured().id"
          class="font-geograph-black"
        >
          {{ featured().name }}
        </h2>

        @if (truncatedDescription()) {
          <p>
            {{ truncatedDescription() }}
          </p>
        }

        <app-button
          [route]="'/projetos/' + featured().slug"
          [label]="translate.translations().seeProject"
          [isLink]="true"
          [size]="'lg'"
          [attr.aria-label]="
            translate.translations().seeProject + ': ' + featured().name
          "
          (click)="selectProject(featured())"
        />
      </div>
    </div>

    <span></span>
  </div>
</article>

<article class="gallery-thumbnails" aria-labelledby="other-projects-title">
  <h2 id="other-projects-title" class="sr-only">
    {{ translate.translations().nav?.work || "Projetos" }}
  </h2>

  <ul>
    @for (item of projects().slice(0, 4); track item.id) {
      <li [id]="item.id">
        <button type="button" (click)="selectProject(item)">
          <img [src]="item.image" [alt]="item.alternativeText" loading="lazy" />
          <span class="font-geograph-black title">
            <app-icon [icon]="item.icon" />
            {{ item.name }}
          </span>
        </button>
      </li>
    }
  </ul>
</article>
